import { getPartnerById } from '../../config';
import { initialState } from '../reducers/partner';

export const selectPartner = (state) => state.get('partner', initialState);

export const selectPartnerId = (state) => selectPartner(state).get('id');

// Returns the full PartnerConfig (including the non-serializable Logo
// component) for the current session. Because partnerId never changes within
// a session and getPartnerById is a static module-level lookup, this returns
// a referentially stable reference — safe to use as an input to reselect.
export const selectPartnerConfig = (state) =>
  getPartnerById(selectPartnerId(state));
